import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../CommonComponents/OPL/Button/Button';

interface Props {
  isNew: boolean;
  isDefault: boolean;
  onReset: () => void;
}

export const Header = ({ isNew, isDefault, onReset }: Props) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb="8">
      <Box
        display="flex"
        flexDirection="column"
        css={({ theme }) => ({ gap: theme.space['8'] })}
        maxWidth="600px"
      >
        <Text as="h2" fontWeight={600} color="neutral.700" fontSize="h4">
          {isNew ? 'Create' : 'Edit'} Personal Finance Template
        </Text>

        <Text color="neutral.500">
          Design a custom layout for the Personal Finances page using sample data. Once saved, this
          template can be assigned to clients via the Client Experience App in Orion Connect.
        </Text>
      </Box>

      {!isDefault && (
        <Button variant="secondary" onClick={onReset}>
          Reset to Default Template
        </Button>
      )}
    </Box>
  );
};
